/**
 * @file MeetingNotesPen.ts
 * @brief Meeting notes' own icon: the Notes pen (PenLine) with its underline as sound bars.
 *
 * @details
 * Mirrors the mobile app's `FRONTEND/src/shared/components/icons/MeetingNotesPen.ts`
 * (DES 08-10-2026, app-specific icons): identical geometry and keys, built
 * with lucide-react's `createLucideIcon` so it takes the same props
 * (size, className, strokeWidth, color) as every lucide icon.
 *
 * @author DES
 * @date 08-10-2026
 */

import { createLucideIcon } from "lucide-react";

export const MeetingNotesPen = createLucideIcon("MeetingNotesPen", [
  // lucide PenLine's pen, unchanged.
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "pen",
    },
  ],
  // Its underline, as three sound bars.
  ["path", { d: "M14 21v-1", key: "bar-1" }],
  ["path", { d: "M17 21v-4", key: "bar-2" }],
  ["path", { d: "M20 21v-2", key: "bar-3" }],
]);

export default MeetingNotesPen;
